module.exports = __webpack_public_path__ + "dcb6f6751e1bc0190309a4742116c4b7.fbx";